export enum MessageNnotificationTypes_Enum {
  "Text" = "Text",
  "Email" = "Email",
  "Both" = "Both"
}

